export interface BackofficeEnvironment {
  production: boolean;
  apiUrl: string;
  knowledgeBaseEnabled: boolean;
}

export const baseEnvironment: BackofficeEnvironment = {
  production: false,
  apiUrl: 'http://localhost:8080',
  knowledgeBaseEnabled: true,
};
